'use strict';

require('babel-polyfill');

require('core-js/es6/map');

require('core-js/es6/set');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = require('react-router-dom');

require('whatwg-fetch');

require('./global-utils');

var _es6Promise = require('es6-promise');

var _es6Promise2 = _interopRequireDefault(_es6Promise);

var _createBrowserHistory = require('history/createBrowserHistory');

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _menuList = require('./components/menu-list');

var _menuList2 = _interopRequireDefault(_menuList);

var _metaNavMobile = require('./components/meta-nav-mobile');

var _metaNavMobile2 = _interopRequireDefault(_metaNavMobile);

var _metaNav = require('./components/meta-nav');

var _metaNav2 = _interopRequireDefault(_metaNav);

var _footer = require('./components/footer');

var _footer2 = _interopRequireDefault(_footer);

var _home = require('./components/home');

var _home2 = _interopRequireDefault(_home);

var _caluculator = require('./components/caluculator');

var _caluculator2 = _interopRequireDefault(_caluculator);

var _notFound = require('./components/not-found');

var _notFound2 = _interopRequireDefault(_notFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_es6Promise2.default.polyfill();

var customHistory = (0, _createBrowserHistory2.default)();

_reactDom2.default.render(_react2.default.createElement(
    _reactRouterDom.Router,
    { history: customHistory },
    _react2.default.createElement(
        _reactRouterDom.Switch,
        null,
        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _home2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/connector-niche', component: _caluculator2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/connector-55', component: _caluculator2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/connector-110', component: _caluculator2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/connector-enclosed', component: _caluculator2.default }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _notFound2.default })
    )
), document.getElementById('app'));

_reactDom2.default.render(_react2.default.createElement(_menuList2.default, null), document.getElementById('main-menu'));
_reactDom2.default.render(_react2.default.createElement(_metaNavMobile2.default, null), document.getElementById('mobile-meta-nav'));
_reactDom2.default.render(_react2.default.createElement(_metaNav2.default, null), document.getElementById('meta-nav'));
_reactDom2.default.render(_react2.default.createElement(_footer2.default, null), document.getElementById('footer'));

// Mobile Nav
var mobileNavTrigger = document.getElementById('mobile-nav-trigger'),
    target = document.querySelector('[data-menu]');

mobileNavTrigger.addEventListener('click', function () {
    if (mobileNavTrigger.classList.contains('is-open')) {
        target.classList.remove('is-open');
        mobileNavTrigger.classList.remove('is-open');
    } else {
        target.classList.add('is-open');
        mobileNavTrigger.classList.add('is-open');
    }
});


//////////////////
// WEBPACK FOOTER
// ./client/main.js
// module id = 190
// module chunks = 0